import styled from "@emotion/styled";
export const LoginGroup = styled.div`
  padding: 1rem 0;
`;
export const LoginItemContent = styled.div`
  display: flex;
  align-items: center;
`;
export const LoginItemInfo = styled.div`
  display: flex;
  margin-left: auto;
`;
